import { __assign } from "tslib";
import React from 'react';
import { Transition } from 'react-transition-group';
var ENTER_DURATION = 120;
var EXIT_DURATION = 80;
var easing = 'cubic-bezier(0.23, 1, 0.32, 1)'; // easeOutQuint
var defaultStyle = function (timeout) { return ({
    transition: "transform " + timeout.enter + "ms " + easing + ", opacity " + timeout.enter + "ms linear",
    opacity: 0,
}); };
var transitionStyle = function (state) {
    var transitions = {
        entering: {},
        entered: {
            opacity: 1,
        },
        exiting: {
            opacity: 0,
        },
    };
    return transitions[state];
};
var getStyle = function (timeout, state) { return function () { return (__assign(__assign({}, defaultStyle(timeout)), transitionStyle(state))); }; };
var Animation = function (_a) {
    var children = _a.children, immediatelyHide = _a.immediatelyHide, immediatelyShow = _a.immediatelyShow, onExited = _a.onExited, inProp = _a.in;
    var timeout = {
        enter: immediatelyShow ? 0 : ENTER_DURATION,
        exit: immediatelyHide ? 0 : EXIT_DURATION,
    };
    return (React.createElement(Transition, { timeout: timeout, in: inProp, onExited: onExited, unmountOnExit: true, appear: true }, function (state) { return children(getStyle(timeout, state)); }));
};
export default Animation;
//# sourceMappingURL=Animation.js.map